 
import JobBreadcrumb from "../../commonComponents/breadcrumbs/JobBreadcrumb";
import JobDetail from "../../commonComponents/productDetail/JobDetail";

const JobDetail1Container = () => {
  return (
    <>
      <JobBreadcrumb />
      <JobDetail />
    </>
  );
};

export default JobDetail1Container;
